import { List, Space, Typography, Upload } from 'antd';
import styled from 'styled-components';

export const UploadContainer = styled(Upload)`
    margin-left: 10px;
`;

export const ContentContainer = styled(Space)`
    width: 100%;
    justify-content: center;
`;

export const StyledTypography = styled(Typography)`
    text-align: center;
`;

export const StyledTypographyLarge = styled(StyledTypography)`
    font-size: 16px;
`;

export const ScrollableList = styled(List)`
    max-height: 100px;
    overflow: auto;
`;

export const ScrollableListBasic = styled.ul`
    max-height: 100px;
    overflow: auto;
`;
